module.exports = __webpack_public_path__ + "static/media/main.0eae514c.png";